import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

enum MapGTMEvents {
    INVEST_MAP_EVENTS = "invest_map_events"
}

export enum MapGTMActions {
    PIN = "pin",
    SIDEBAR = "sidebar"
}

export enum MapGTMLabel {
    INVEST = "invest",
    LISTING = "listing",
    CLOSE = "close"
}

export const gtmEventMapList = (action: string, label: string | number) => {
    const gtmData = {
        event: MapGTMEvents.INVEST_MAP_EVENTS,
        action,
        label
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

enum MapGTMEvents {
    INVEST_MAP_EVENTS = "invest_map_events"
}

export enum MapGTMActions {
    PIN = "pin",
    SIDEBAR = "sidebar"
}

export enum MapGTMLabel {
    INVEST = "invest",
    LISTING = "listing",
    CLOSE = "close"
}

export const gtmEventMapList = (action: string, label: string | number) => {
    const gtmData = {
        event: MapGTMEvents.INVEST_MAP_EVENTS,
        action,
        label
    };

    hitGoogleTagManager(gtmData);
};
